module.exports = __webpack_public_path__ + "static/img/banner.0cc97825.png";